import type { CustomsQueueRow } from '@crm/shared'

/**
 * Ключ партномера для подсчёта уникальных строк файла брокеру на сайте:
 * без лишних пробелов (и вокруг «-» и «/»), в верхнем регистре. Точную
 * группировку (с кириллицей-двойниками) делает сервер — `normalizeArtKey`.
 */
export function partKey(partNumber: string): string {
  return partNumber
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\s*([-/])\s*/g, '$1')
    .toUpperCase()
}

/** Узел грида — ровно то, что нужно для отбора видимых отмеченных строк. */
interface SelectableNode {
  displayed: boolean
  data?: { id: string }
}

/**
 * Отмеченные строки, которые видны в гриде. Строка, скрытая фильтром колонки,
 * в массовое действие не попадает, даже если её отметили до фильтра.
 */
export function visibleSelectedIds(api: { getSelectedNodes(): SelectableNode[] }): string[] {
  return api
    .getSelectedNodes()
    .filter((n) => n.displayed && n.data)
    .map((n) => n.data!.id)
}

export function countUniqueParts(rows: CustomsQueueRow[]): number {
  return new Set(rows.map((r) => partKey(r.partNumber)).filter(Boolean)).size
}

/** Склонение «позиция»: 1 позиция, 2 позиции, 5 позиций. */
export function pluralPositions(n: number): string {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return `${n} позиция`
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${n} позиции`
  return `${n} позиций`
}
